import * as d3 from "d3";
import i18n from "../../lang/lang.js";

export const createTooltip = (chart, tooltipName, textFn, svg) => {
  var hasTooltip = document.getElementById(tooltipName);

  if (!hasTooltip) {
    // tooltips
    d3.select("body")
      .append("div")
      .attr("id", tooltipName)
      .attr("style", "position: absolute; opacity: 0;top:0;left:0")
      .attr("class", tooltipName);
  }

  chart
    .on("mouseover", function (event, d) {
      d3.select(`#${tooltipName}`)
        // .transition()
        // .duration(200)
        .style("opacity", 1)
        .text(textFn(d));
    })
    .on("mouseout", function (event) {
      d3.select(`#${tooltipName}`).style("opacity", 0);
    })
    .on("mousemove", function (event) {
      d3.select(`#${tooltipName}`)
        .style("left", event.pageX + 10 + "px")
        .style("top", event.pageY + 10 + "px");
    });
};

export const createTooltipBuilder = (chart, tooltipName, buildHtml) => {
  var hasTooltip = document.getElementById(tooltipName);

  if (!hasTooltip) {
    // tooltips
    d3.select("body")
      .append("div")
      .attr("id", tooltipName)
      .attr("style", "position: absolute; display: none;top:0;left:0")
      .attr("class", tooltipName);
  }

  chart
    .on("mouseover", function (event, d) {
      d3.select(`#${tooltipName}`).selectAll().remove();

      if (document.getElementById(tooltipName)) {
        d3.select(`#${tooltipName}`).html(buildHtml(d));
      }

      d3.select(`#${tooltipName}`).style("display", "block");

      setTimeout(() => {
        d3.select(`#${tooltipName}`).style(
          "transition",
          "top 0.3s ease-out, left 1s ease-out"
        );
      });
    })
    .on("mouseout", function (event) {
      d3.select(`#${tooltipName}`)
        .style("display", "none")
        .style("transition", "none");
    })
    .on("mousemove", function (event, d) {
      if (document.getElementById(tooltipName)) {
        d3.select(`#${tooltipName}`).html(buildHtml(d));
      }
      d3.select(`#${tooltipName}`)
        .style("left", event.pageX + 10 + "px")
        .style("top", event.pageY + 10 + "px")
        .style("transform", "translateX(-50%) translateY(-150%)");
    });
};

export function wrap(text, width) {
  text.each(function () {
    var text = d3.select(this);
    var textbk = text.text();
    var words = text.text().split(/\s+/).reverse();
    var word;
    var line = [];
    var lineNumber = 0;
    var lineHeight = 1.1; // ems
    var x = text.attr("x");
    var y = text.attr("y");
    var dy = 0; //parseFloat(text.attr("dy")),
    var tspan = text
      .text(null)
      .append("tspan")
      .attr("x", x)
      .attr("y", y)
      .attr("dy", dy + "em");
    var numberOfRows = 0;
    setTimeout(() => {
      while ((word = words.pop())) {
        numberOfRows++;
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text
            .append("tspan")
            .attr("x", x)
            .attr("y", y)
            .attr("dy", ++lineNumber * lineHeight + dy + "em")
            .text(word);
        }
      }
      if (numberOfRows === 1) {
        //    text.remove()
        text.text(textbk);
      }
    });
  });
}

export function wrapVertical(text, width) {
  text.each(function () {
    var text = d3.select(this);
    var textbk = text.text();
    var words = text.text().split(/\s+/).reverse();
    var word;
    var line = [];
    var lineNumber = 0;
    var lineHeight = 1.1; // ems
    var y = text.attr("y");
    var dy = 0.5; //parseFloat(text.attr("dy"))
    var tspan = text
      .text(null)
      .append("tspan")
      .attr("x", 0)
      .attr("y", y)
      .attr("dy", dy + "em");
    var numberOfRows = 0;
    setTimeout(() => {
      while ((word = words.pop())) {
        numberOfRows++;
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          if (word) {
            tspan = text
              .append("tspan")
              .attr("x", 0)
              .attr("y", 0)
              .attr("dy", `${++lineNumber * lineHeight + dy}em`)
              .text(word);
          }
        }
      }
    });
  });
}

export function ellipsis(text, width) {
  text.each(function () {
    var text = d3.select(this);
    var words = text.text();
    var x = text.attr("x");
    var y = text.attr("y");
    var tspan = text.text(null).append("tspan").attr("x", x).attr("y", y);
    setTimeout(() => {
      tspan.text(words);
      while (tspan?.node().getComputedTextLength() > width) {
        words = words.slice(0, -1);
        tspan.text(words + "...");
      }
    });
  });
}

export function fitFontSize(text, width, maxFontSize = 25) {
  setTimeout(function () {
    var smallest = 0;

    text.each(function () {
      var text = d3.select(this);
      var max = 50;
      while (text?.node().getComputedTextLength() > width && max > 0) {
        text.attr("font-size", +text.attr("font-size") * 0.9);
        max--;
      }

      var finalSize = +text.attr("font-size");

      if (!smallest || smallest > finalSize) {
        smallest = finalSize;
      }
    });

    if(smallest > maxFontSize) {smallest=maxFontSize;}
    text?.node().getComputedTextLength();
    text.each(function () {
      var text = d3.select(this);
      text.attr("font-size", smallest);
    });
  });
}

export function moveTotal(text, maxValue, separation) {
  text.each(function () {
    var text = d3.select(this);
    var words = text.text();
    var x = text.attr("x");
    var y = text.attr("y");
    setTimeout(() => {
      if (+x + +text.node().getComputedTextLength() > maxValue) {
        text.attr(
          "x",
          +x - +text.node().getComputedTextLength() - separation * 2
        );
        text.style("fill", "white");
      }
    });
  });
}

export function moveTotalLeft(text, maxValue, separation) {
  setTimeout(() => {
    text.each(function () {
      var text = d3.select(this);
      var words = text.text();
      var x = text.attr("x");
      var y = text.attr("y");
      if (+x < maxValue) {
        text.attr("x", +text.attr("original-x") + separation);
        text.style("fill", "white");
      }
    });
  });
}

export function avoidTouchingBar(text, separation) {
  text.each(function () {
    var text = d3.select(this);
    var words = text.text();
    var x = text.attr("x");
    var y = text.attr("y");
    setTimeout(() => {
      text.attr("original-x", +x);
      text.attr("x", +x - +text.node().getComputedTextLength() - separation);
    });
  });
}

export function avoidCeilingOutside(text, center) {
  text.each(function () {
    var text = d3.select(this);
    var words = text.text();
    var x = text.attr("x");
    var y = text.attr("y");
    setTimeout(() => {
      if (+y < 30) {
        text.style("fill", "white");
        text.attr("y", center);
      }
    });
  });
}

export function translate(text) {
  text.each(function () {
    var text = d3.select(this);
    text.text(i18n.t(text.text()));
  });
}

export function replaceWithNewText(textElem, newText) {
  textElem.each(function () {
    var text = d3.select(this);
    text.text(newText);
  });
}


export function generateUUID() { // Public Domain/MIT
  var d = new Date().getTime();//Timestamp
  var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16;//random number between 0 and 16
    if(d > 0){//Use timestamp until depleted
      r = (d + r)%16 | 0;
      d = Math.floor(d/16);
    } else {//Use microseconds since page-load if supported
      r = (d2 + r)%16 | 0;
      d2 = Math.floor(d2/16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}
